import { EventEmitter } from "@angular/core";
import { timer } from "rxjs";
import { environment } from "../../../environments/environment";
const randomData = Math.floor(10+Math.random() * 100);
/**
* 插播广告管理器
*/
export class interstitialData {
    public event: number;
    public data: object
};
export enum intersitialEvent {
    Timer = randomData,
    SkipTimer = randomData+1,
    ShouldPlayAds = randomData+2,
    ShouldLoadAds = randomData+3, ///预先加载广告
    ShouldBackToPlay = randomData+4, ///播会正片
    ShouldCancel = randomData+5,
    StandBy = randomData+6,

}


export class interstitialManager {

    public pointToshow = [];

    dispose(): void {
        if (this.globalsubscript) {
            this.globalsubscript.unsubscribe();
        }

        if (this.subscript) {
            this.subscript.unsubscribe();
        }
    }


    constructor() {

        this.maxSecond = 20;
        this.startSecond = 20;
        this.everySecond = 50;

        if (!environment.production) {
            this.maxSecond = 5;
        }

    }
    private dataEvent = new EventEmitter<interstitialData>();//视频结束时
    public subscribe(func)
    {
        return this.dataEvent.subscribe(func)
    }

    //public timer = null;
    public subscript = null;
    public globalsubscript = null;
    public dataList = [];
    // public startList = [];
    public maxSecond = 20; ///最长播放时间
    public waitSecond = 5; /// 等待时间
    public skipSecond = 0; /// 跳过时间
    public startSecond = 60 * 10;///开始播放时间
    public everySecond = 60 * 20;///每次播放时间
    public isPlayingAds = false;
    public static isUseGolbal = false;
    //globaltimer: Observable<number> = null;
    public state = intersitialEvent.StandBy;



    public invokeList(dataList: Array<any>, startSecond, periodicSecond) {
        if (startSecond > -1) {
            this.startSecond = startSecond;

        }

        if (periodicSecond > 0) {
            this.everySecond = periodicSecond;

        }

        for (var i = 0; i < dataList.length; ++i) {
            if (dataList[i].playfirst) {
                // this.startList.push(dataList[i]);
            }
            else {
                this.dataList.push(dataList[i]);
            }
        }
        //this.startList = this.dataList ;//COMMET OUT!!!


        if (interstitialManager.isUseGolbal) /// 是否使用全局计时器？
        {
            this.globalsubscript = timer(this.startSecond * 1000, this.everySecond * 1000).subscribe(ticks => {

                if (this.ispaused) {
                    return;
                }

                if (!this.isPlayingAds) {
                    this.play();
                }


            });
        }
        else {


            //TODO: stick to time
        }

        //this.globaltimer.
    }



    /**
     * 重置计时器
     */
    public reset() {
        //console.log("canceled")
        // if (this.timer) {
        //     this.timer = null;
        // }
        if (this.subscript) {
            this.subscript.unsubscribe();
        }
        this.dataEvent.emit({
            event: intersitialEvent.ShouldCancel,
            data: {}
        });
        this.isPlayingAds = false;

        this.pointToshow.forEach((data) => {
            data.played = false;
        })
        this.state = intersitialEvent.ShouldCancel;
        this.attenpToPlay = false;
    }

    public cancel() {
        this.pointToshow.forEach((data) => {
            data.played = true;
        });
        // console.log(this.pointToshow);
    }
    // public cancel()
    // {
    //     if(this.globalsubscript)
    //     {
    //         this.globalsubscript.unsubscribe();
    //     }
    //     if (this.timer) {
    //         this.timer = null;
    //     }
    //     if (this.subscript) {
    //         this.subscript.unsubscribe();
    //     }
    //     this.pointToshow.forEach((data)=>{

    //         data.played = true;
    //     })
    // }

    public continue() {

    }
    public stopPlay() {
        // if (this.timer) {
        //     this.timer = null;
        // }

        if (this.subscript) {
            this.subscript.unsubscribe();
        }

        this.attenpToPlay = false;

        this.dataEvent.emit({
            event: intersitialEvent.ShouldBackToPlay,
            data: {}
        });

        // console.log("stop");
        //console.log(this.attenpIndex);

        this.state = intersitialEvent.ShouldBackToPlay;
        this.pausesecond = 0;

        this.isPlayingAds = false;

        console.log("ads play success");
    }

    private ispaused = false;
    private pausesecond = 0;
    public pause() {
        this.ispaused = true;
    }

    public renew() {
        this.ispaused = false;

    }
    public index = 0;
    public play() {
        if (this.dataList.length > this.index) {
        }
        else {
            this.index = 0;
        }
        this.startPlay(this.dataList[this.index]);
        ++this.index;
    }
    /**
     * 开始加载
     */
    public startPlay(playItem) {
        // this.dataList = dataList;

        //var playItem = null;
        //if (this.dataList.length > 0)
        //{
        //    playItem = this.dataList.splice(0, 1)[0];
        //}

        if (!!playItem) {
            // if (this.timer) {
            //     this.timer = null;
            // }
            if (this.subscript) {
                this.subscript.unsubscribe();
            }
            this.subscript = timer(1000, 1000).subscribe((ticks) => {

                if (this.ispaused) {
                    ++this.pausesecond;
                    return;
                }
                if (ticks - this.pausesecond == this.waitSecond) {
                    this.dataEvent.emit({
                        event: intersitialEvent.Timer+2,
                        data: {}
                    });
                    this.state = intersitialEvent.Timer+2;
                    this.subscript.unsubscribe();
                    this.subscript = null;
                    this.startLoadCounter();

                }
                else {
                    this.dataEvent.emit({
                        event: intersitialEvent.Timer,
                        data: { time: ((this.waitSecond + this.pausesecond - ticks) + "") }
                    });
                    this.state = intersitialEvent.Timer;

                }

            });
            this.isPlayingAds = true;
            this.dataEvent.emit({
                event: intersitialEvent.ShouldLoadAds,
                data: playItem
            });
            this.state = intersitialEvent.ShouldLoadAds;

        }

    }

    /*
    ** 在播放广告之前，开始计时
    */
    public startCountDown(totalTime, everySecond, callback) {
        this.subscript = timer(0, 1000).subscribe((ticks) => {

            if (this.ispaused) {
                ++this.pausesecond;
                return;
            }
            if (ticks - this.pausesecond == totalTime) {
                this.subscript.unsubscribe();
            }
            if ((ticks - this.pausesecond) % everySecond == 0) {
                callback();
            }
            this.dataEvent.emit({
                event: intersitialEvent.SkipTimer,
                data: {
                    time:
                        ((this.skipSecond - ticks + this.pausesecond) + ""), left: ((totalTime - ticks + this.pausesecond))
                }
            });
            this.state = intersitialEvent.SkipTimer;

        });
    }
    //private otherTimer = null;
    //private otherSubscrit = null;
    /**
     * 播放广告，倒计时
     */
    private startLoadCounter() {
        this.subscript = timer(0, 500).subscribe((ticks) => {
            var myTicks = ticks / 2;
            if (myTicks > this.maxSecond) {
                this.stopPlay();

            }
            else {
                this.dataEvent.emit({
                    event: intersitialEvent.SkipTimer,
                    data: {
                        time:
                            ((this.skipSecond - parseInt(myTicks + "")) + ""), left: ((this.maxSecond - parseInt(myTicks + "")))
                    }
                });
                this.state = intersitialEvent.SkipTimer;

            }

        });
    }
    key = "";
    /*
    ** 根据总时间，分布插播广告。
    */
    getTimeDefine(key, totalTime) {
        if (!this.key || this.key != key) {
            //console.log(this.key ,key)
            this.key = key;
            var result: any = [];

            if (totalTime < 15 * 60) {
                return;
            } else if ((totalTime - 2 * 60) < 70 * 60) {

                result.push({
                    point: Math.floor(totalTime / 2),
                    played: false
                });
                
            } else {
                // 最多播两次广告
                for (var j = 0; j < 2; ++j) {
                    result.push({
                        point: Math.floor(totalTime / 3) * (j + 1),
                        played: false
                    });
                }
            }
            this.pointToshow = result;
        }
    }


    private attenpToPlay = false;
    // private attenpIndex = -1;
    public needToShow(time) {
        //console.log(this.pointToshow,time,this.attenpToPlay)
        //console.log(time,this.attenpToPlay);
        //console.log(this.pointToshow)
        if (!this.attenpToPlay
            && time > 0
            && this.pointToshow.length > 0
        ) {
            var maxPoint = this.pointToshow[this.pointToshow.length - 1];
            var index = -1;
            //console.log(time,maxPoint)
            if (time > maxPoint.point) /// 如果时间点大于最大的广告时间点
            {
                if (!maxPoint.played) /// 最后一个广告还没播放就播放,否者不播放
                {
                    index = this.pointToshow.length - 1;
                }
                //this.pointToshow[]  //this.pointToshow.findIndex(p=>!p.played && time > p.point );

            }
            else {

                for (var i = 0; i < this.pointToshow.length - 1; ++i) {
                    if (time > this.pointToshow[i].point
                        && time < this.pointToshow[i + 1].point
                        && !this.pointToshow[i].played
                    ) {
                        index = i;
                        break;
                    }
                }
            }

            if (index > -1) {
                this.attenpToPlay = true;
                this.pointToshow[index].played = true;
                this.play();
            }


        }

        // return false;
    }
}
